import { Box, Grid } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import Feed from '../../../Feed';
import Image from '../../../../fl-components/Image';
// import FeaturedClasses from './FeaturedClasses';
import WelcomeBanner from '../../../../components/common/WelcomeBanner';
import { getAllFeedsByOrg } from '../../../../service/feed.service';
import { SET_ORG_FEEDS } from '../../../../redux/constants';
import { SkeletonFeed } from '../../../../fl-components/skeleton';
import OfferBanner from './OfferBanner';

export default function StudentFeedDashboard() {
  const selectedOrg = useSelector((state) => state.org.selectedOrg);
  const feedList = useSelector((state) => state.feeds.orgFeeds);
  const feedOffset = useSelector((state) => state.feeds.orgFeedOffset);
  const feedHasMore = useSelector((state) => state.feeds.orgFeedHasMore);
  const dispatch = useDispatch();
  const [isDataFetching, setIsDataFetching] = useState(false);

  const fetchFeeds = async () => {
    const res = await getAllFeedsByOrg(selectedOrg?.id ?? selectedOrg?.orgId, feedOffset);
    if (res) {
      dispatch({
        type: SET_ORG_FEEDS,
        payload: {
          feeds: res.results,
          offset: feedOffset + 1
        }
      });
    }
    setIsDataFetching(false);
  };

  useEffect(() => {
    if ((selectedOrg?.id ?? selectedOrg?.orgId) && feedList === null) fetchFeeds();
  }, []);

  return (
    <Box>
      <Grid
        container
        spacing={{
          sm: 1,
          xs: 3
        }}
      >
        <Grid
          item
          md={8}
          xs={12}
          pr={{
            sm: 3
          }}
          mb={{
            sm: 3
          }}
          sx={{
            overflowY: 'scroll',
            height: '100vh',
            '&::-webkit-scrollbar': {
              display: 'none',
              width: '0px'
            },
            '&::-webkit-scrollbar-track': {
              width: '0px'
            }
          }}
          id="feed-container"
        >
          <Box>
            <WelcomeBanner
              title="Welcome Back"
              description="If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything."
              action={() => {}}
              img={
                <Box
                  width={{
                    sm: '360px'
                  }}
                  margin={{
                    sm: '0 auto'
                  }}
                >
                  <Image
                    src="/static/illustrations/illustration_welcome.svg"
                    sx={{
                      p: 2,
                      height: { sm: 250, xl: 300 },
                      span: {
                        display: 'flex !important',
                        alignItems: 'center !important'
                      }
                    }}
                    imageStyle={{ width: '100% !important', height: 'auto !important' }}
                  />
                </Box>
              }
            />
            <Box
              pt={3}
              sx={{
                '.MuiCard-root:last-child ': {
                  mb: 3
                }
              }}
            >
              <InfiniteScroll
                pageStart={0}
                loadMore={() => {
                  if (feedHasMore && !isDataFetching) {
                    fetchFeeds();
                    setIsDataFetching(true);
                  }
                }}
                hasMore={feedHasMore}
                getScrollParent={() => document.getElementById('feed-container')}
                loader={
                  <Box my={4}>
                    <SkeletonFeed />
                  </Box>
                }
                useWindow={false}
              >
                <Feed feedDetails={feedList} editable={false} />
              </InfiniteScroll>
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          md={4}
          xs={12}
          sx={{ position: 'sticky !important', alignSelf: 'flex-start !important', top: 0 }}
        >
          <OfferBanner />
          {/* <FeaturedClasses />
          <Box pt={3}>
            <FeaturedClasses />
          </Box>
          <Box pt={3}>
            <Button onClick={() => navigate('/dashboard/discover', { replace: true })}>
              Discover More
            </Button>
          </Box> */}
        </Grid>
      </Grid>
    </Box>
  );
}
